import React, { useEffect, useState } from 'react';
import { TrustedByBrands } from './TrustedByBrands/TrustedByBrands';
import { VisitingHistory } from './VisitingHistory/VisitingHistory';
import { VisitorTrackingWelcome } from './VisitorTrackingWelcome/VisitorTrackingWelcome';
import { VisitsReportWelcome } from './VisitsReportWelcome/VisitsReportWelcome';
import { VisitModel } from '@mm/state/controllers/VisitsController';
import { useResolutionInfo } from '@mm/hooks/src/use-resolution-info';
import { MOBILE_THRESHOLD } from '../../../editor/constants/screenSize';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { useVisitorCRUDActions } from '@mm/state/actions/VisitorCRUDActions';
import visitsCRUDActions from '@mm/state/actions/VisitsCRUDActions';

export const VisitsReport = () => {
  const [userVisits, setUserVisits] = useState<VisitModel[]>([]);
  const visitorId = useSelector((state: StoreState) => state.visitor.visitorId);
  const { getVisitorId } = useVisitorCRUDActions();

  useEffect(() => {
    if (!visitorId) {
      getVisitorId();
    }
  }, []);

  useEffect(() => {
    const fetchUserVisists = async () => {
      if (!visitorId) {
        return;
      }

      const visits = await visitsCRUDActions.getVisits(visitorId);
      setUserVisits(visits);
    };

    fetchUserVisists();
  }, [visitorId]);

  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_THRESHOLD;

  return (
    <div>
      <VisitsReportWelcome userVisits={userVisits} isMobile={isMobile} />
      {userVisits.length >= 2 && (
        <VisitingHistory userVisits={userVisits} isMobile={isMobile} />
      )}
      <VisitorTrackingWelcome isMobile={isMobile} />
      <TrustedByBrands />
    </div>
  );
};
